import { render, staticRenderFns } from "./branding.vue?vue&type=template&id=173cdeaa&scoped=true&"
import script from "./branding.vue?vue&type=script&lang=js&"
export * from "./branding.vue?vue&type=script&lang=js&"
import style0 from "./branding.vue?vue&type=style&index=0&id=173cdeaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173cdeaa",
  null
  
)

export default component.exports